import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  fetchKbCategoriesListAll,
  deleteKbCategory,
  toggleKbCategoryStatus,
} from "../../services/axios/apiManager";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5";
import DashboardLayout from "../DashboardLayout";
import AddKbCategoryModal from "./addKbCategoryModal";

const KbCategoriesList = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showCatModal, setShowCatModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const tableRef = useRef(null);

  const fetchCategories = async () => {
    setLoading(true);
    const response = await fetchKbCategoriesListAll();
    if (response?.data?.success) {
      setCategories(response.data.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleToggleStatus = (category) => {
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to ${category.status === 1 ? "deactivate" : "activate"} "${category.name}"?`,
      okay: "Confirm",
      method: async () => {
        const response = await toggleKbCategoryStatus({
          id: category.id,
          status: category.status === 1 ? 0 : 1,
        });
        if (response?.data?.success) {
          toast.success("Status updated");
          fetchCategories();
        }
        setShowOptionsModal(false);
      },
    });
    setShowOptionsModal(true);
  };

  const handleDelete = (category) => {
    setModalOptions({
      header: "Delete Category",
      body: `Are you sure you want to delete "${category.name}"? This may affect articles in this category.`,
      okay: "Delete",
      method: async () => {
        const response = await deleteKbCategory(category.id);
        if (response?.data?.success) {
          toast.success("Category deleted");
          fetchCategories();
        }
        setShowOptionsModal(false);
      },
    });
    setShowOptionsModal(true);
  };

  useEffect(() => {
    const rows = categories.map((c) => [
      c.name,
      c.slug,
      c.description || "N/A",
      c.status === 1 ? "Active" : "Inactive",
      "", // Actions
    ]);

    const config = {
      data: rows,
      columns: [
        { title: "Name" },
        { title: "Slug" },
        { title: "Description" },
        { title: "Status" },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      paging: true,
      searching: true,
      info: true,
      responsive: true,
      createdRow: (row, data, idx) => {
        const category = categories[idx];
        const $row = $("td", row);

        // Status toggle
        const $status = $(
          `<button class="btn btn-link p-0 ${category.status === 1 ? "text-success" : "text-warning"}">${data[3]}</button>`,
        ).on("click", () => handleToggleStatus(category));
        $row.eq(3).empty().append($status);

        // Actions
        const $act = $row.eq(4).empty().css("display", "flex");
        $act.append(
          $(
            `<button class="btn btn-outline-primary btn-sm me-1"><i class="fa fa-edit"></i></button>`,
          ).on("click", () => {
            setEditData(category);
            setShowCatModal(true);
          }),
        );

        $act.append(
          $(
            `<button class="btn btn-outline-danger btn-sm"><i class="fa fa-trash"></i></button>`,
          ).on("click", () => handleDelete(category)),
        );
      },
    };

    const $tbl = $(tableRef.current);
    if ($.fn.dataTable.isDataTable($tbl)) {
      $tbl.DataTable().clear().rows.add(rows).draw();
    } else {
      $tbl.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable($tbl)) $tbl.DataTable().destroy();
    };
  }, [categories]);

  return (
    <DashboardLayout>
      <div className="container text-light bg-dark rounded mb-4 p-4 shadow">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="text-success">Knowledge Base Categories</h3>
          <div>
            <Button
              variant="outline-secondary"
              className="me-2"
              onClick={() => navigate("/KbManagement")}
            >
              Back to Articles
            </Button>
            <Button variant="success" onClick={() => {
              setEditData(null);
              setShowCatModal(true);
            }}>
              Add New Category
            </Button>
          </div>
        </div>

        <div className="position-relative">
          {loading && (
            <div
              className="position-absolute top-50 start-50 translate-middle"
              style={{ zIndex: 10 }}
            >
              <LoadingSpinner size="lg" />
            </div>
          )}

          <div className={`table-responsive ${loading ? "opacity-50" : ""}`}>
            <table
              ref={tableRef}
              className="table table-dark table-striped w-100"
            />
          </div>
        </div>

        <Modal
          show={showOptionsModal}
          onHide={() => setShowOptionsModal(false)}
          centered
        >
          <Modal.Header closeButton className="bg-dark text-light border-0">
            <Modal.Title>{modalOptions.header}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-dark text-light">
            {modalOptions.body}
          </Modal.Body>
          <Modal.Footer className="bg-dark text-light border-0">
            <Button
              variant="secondary"
              onClick={() => setShowOptionsModal(false)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={modalOptions.method}>
              {modalOptions.okay}
            </Button>
          </Modal.Footer>
        </Modal>

        <AddKbCategoryModal
          show={showCatModal}
          editData={editData}
          onHide={() => {
            setShowCatModal(false);
            setEditData(null);
          }}
          onSuccess={() => {
            fetchCategories();
          }}
        />
      </div>
    </DashboardLayout>
  );
};

export default KbCategoriesList;
